import React, { useEffect, useMemo, useState, useRef, useCallback } from 'react'
import { Layer, Image as KonvaImage } from 'react-konva'
import { ImageAsset, VideoAsset } from '../../../models/Asset'
import { getAbsoluteAssetSize } from '../../../helpers/getAbsoluteAssetSize'
import { useColorProvider } from '../../../hooks/useColorProvider'

const ColorPicker = React.memo(({
  asset,
  index,
  scale,
  boundingRect,
  referenceAsset,
  videoRefs,
}) => {
  const { colorProvider } = useColorProvider(`Chroma-key-${asset.id}`)
  const layer = useRef()
  const [ source, setSource ] = useState()

  const { width, height } = useMemo(() => {
    const { width, height } = getAbsoluteAssetSize(asset, referenceAsset)
    return {
      width: width * scale.x,
      height: height * scale.y,
    }
  }, [ asset, referenceAsset, scale ])

  const onClick = useCallback(() => {
    const { x, y } = layer.current.getStage().getPointerPosition()
    const [ r, g, b ] = layer.current.getCanvas().getContext().getImageData(x, y, 1, 1).data
    colorProvider.provideColor({ rgb: { r, g, b, a: 1 } })
  }, [ layer, colorProvider ])

  const setCursor = useCallback(cursor => {
    layer.current.getStage().content.style.cursor = cursor
  }, [ layer ])

  useEffect(() => {
    if (layer.current) {
      // eslint-disable-next-line no-underscore-dangle
      layer.current.getCanvas()._canvas.style.zIndex = index
    }
  }, [ layer, index ])

  useEffect(() => {
    // eslint-disable-next-line consistent-return
    const init = () => new Promise(resolve => {
      if (asset instanceof VideoAsset) {
        resolve(videoRefs?.[asset.id]?.current)
        return undefined
      }

      if (asset instanceof ImageAsset) {
        const img = new Image()
        img.onload = () => resolve(img)
        img.crossOrigin = 'Anonymous'
        img.src = asset.url
      }
    })

    init().then(ref => setSource(ref))

    return undefined
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
    <Layer
      clip={boundingRect}
      onClick={onClick}
      onMouseOver={() => setCursor('url(https://icons.iconarchive.com/icons/led24.de/led/16/pipette-icon.png) -16 32, default')}
      onMouseOut={() => setCursor('default')}
      ref={layer}
    >
      <If condition={source}>
        <KonvaImage
          image={source}
          width={width}
          height={height}
        />
      </If>
    </Layer>
  )
})

export default ColorPicker
